export const STATUS_STACK = 1;
export const STATUS_ACTIVE = 3;
export const STATUS_CLOSE = 6;
export const TICKET_STATUS = ['Undefined', 'Queued', 'SentToTote', 'Open', 'RejectedByTote', 'Cancelled', 'Final', 'Closed', 'Deleted', 'MoveToWager', 'InternalError', 'Not Issued'];
